import useQuery from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { getRedirectURI } from '../state/actions'
import { redirectUriCacheKey } from './cache-keys'
import { useLocation } from 'react-router-dom'

export const useGetRedirectURI = (onSuccess?: (data: string) => void) => {
  const dispatch = useDispatch()
  const location = useLocation()

  return useQuery(
    redirectUriCacheKey(),
    async () => {
      const { Data } = await dispatch(getRedirectURI())
      const url = Data.URL
      const host = window.location.host
      const redirectUri = `https://${host}/auth/login`

      const { pathname, search } = location
      const searchParams = new URLSearchParams(search)

      const redirectPath = pathname + search || searchParams.get('redirect') || '/'
      const state = encodeURIComponent(btoa(JSON.stringify({ redirect: redirectPath })))
      // Only set redirect_uri , as this is the only one used by Azure and attach rest in state
      const redirectURI = url.replace('{redirect_uri}', encodeURIComponent(redirectUri)).concat(`&state=${state}`)
      return redirectURI
    },
    { onSuccess, refetchOnWindowFocus: false }
  )
}
